(function () {
	const searchModal = () => {
		jQuery(".search-modal-trigger,.search-modal__overlay,.search__close").click(
			function (e) {
				e.preventDefault();
				searchToggle()
			}
		);
	};
	jQuery(document).on('keyup', function(e) {
		if (jQuery(".search-modal").hasClass('active') && e.key == "Escape") {
			searchToggle()
		}
	});
	function searchToggle(){
		jQuery("#search-modal").toggleClass("active");
		if (jQuery("#search-modal").hasClass('active')) {
			jQuery("#search-modal").find('.search__input').focus();
			console.log(jQuery("#search-modal").find('.search__input'));
		} else {
			jQuery(".search-modal-trigger").focus();
		}
		jQuery('body').toggleClass("overflow-hidden")
	}
	document.addEventListener("shopify:section:load", searchModal);
	searchModal();
})();
